import React, { useState, useEffect } from 'react';
import { Input } from 'reactstrap';
import { convocatoriasAgotadas } from '../../../helpers/convocatorias';

export const InputModulos = ({
  obj,
  modulos,
  setIsEnabled,
  setModulos,
  setHoursCounter,
  hoursCounter,
  total,
  setTotal,
  total2,
  setTotal2,
  totalSuelto,
  setTotalSuelto,
  totalSuelto2,
  setTotalSuelto2,
}) => {
  // Preparamos variables necesarias
  const [isChecked, setIsChecked] = useState(false);

  // Efectos
  useEffect(() => {
    if (modulos.includes(`${obj.modulo} ${obj.descripcion}`)) {
      setIsChecked(!isChecked);
      setIsEnabled(false);
    }
  }, []);

  // Función para controlar los cambios de los checkbox
  const handleCheckboxChange = (e) => {
    const splitted = e.target.value.split('HH');
    const newModulo = splitted[0].trim().normalize(); // Normalizamos y quitamos espacios
    const notaAsInt = parseInt(splitted[1], 10);

    const isAlreadyAdded = modulos.some((mod) => mod.trim().normalize() === newModulo);

    if (!isAlreadyAdded) {
      // Añadir módulo
      if (
        !newModulo.includes('Formación en el centro de trabajo') &&
        !newModulo.includes('Formación en centros de trabajo')
      ) {
        setHoursCounter(hoursCounter + notaAsInt);
      }

      if (obj.curso === 'PRIMERO') {
        setTotal(total + obj.precio);
        setTotalSuelto(totalSuelto + obj.importe_suelto);
      } else {
        setTotal2(total2 + obj.precio);
        setTotalSuelto2(totalSuelto2 + obj.importe_suelto);
      }

      setModulos([...modulos, newModulo]);
    } else {
      // Quitar módulo
      if (
        !newModulo.includes('Formación en el centro de trabajo') &&
        !newModulo.includes('Formación en centros de trabajo')
      ) {
        setHoursCounter(hoursCounter - notaAsInt);
      }

      if (obj.curso === 'PRIMERO') {
        setTotal(total - obj.precio);
        setTotalSuelto(totalSuelto - obj.importe_suelto);
      } else {
        setTotal2(total2 - obj.precio);
        setTotalSuelto2(totalSuelto2 - obj.importe_suelto);
      }

      setModulos(modulos.filter((mod) => mod.trim().normalize() !== newModulo));
    }

    // Toggle del checkbox
    setIsChecked(!isChecked);

    // Habilitar o deshabilitar según si hay módulos
    setIsEnabled(modulos.length === 0);
  };

  return (
    <Input
      type="checkbox"
      id={obj.codigo}
      name="option"
      value={`${obj.modulo} ${obj.descripcion} HH${obj.horas}`}
      onChange={handleCheckboxChange}
      checked={modulos.includes(`${obj.modulo} ${obj.descripcion}`)}
      disabled={obj.Nota === 1 || convocatoriasAgotadas(obj)}
    />
  );
};
